import { render, staticRenderFns } from "./EmergencyBanner.vue?vue&type=template&id=13012252&scoped=true"
import script from "./EmergencyBanner.vue?vue&type=script&lang=js"
export * from "./EmergencyBanner.vue?vue&type=script&lang=js"
import style0 from "./EmergencyBanner.vue?vue&type=style&index=0&id=13012252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../pws_portal/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13012252",
  null
  
)

export default component.exports